import React from "react";
import ElectricityProductSelect from "../ElectricityProductSelect";

const ElectricityProductSelectField = ({ input, label, meta, ...rest }) => {
  return (
    <div>
      <ElectricityProductSelect
        {...input}
        {...rest}
      />
      {meta.error && meta.touched && (
        <span
          style={{
            fontSize: "12px",
            lineHeight: "12px",
            color: "rgb(244, 67, 54)",
          }}
        >
          {meta.error}
        </span>
      )}
    </div>
  );
};

export default ElectricityProductSelectField;
